import { useQuery } from "@tanstack/react-query";
import { Check, X } from "lucide-react";
import { api } from "@/lib/api";
import { Avatar } from "./Avatar";
import { useFriendActions } from "./useFriendActions";

export const useFriendRequests = () => useQuery({ queryKey: ["friendRequests"], queryFn: api.friendRequests, refetchInterval: 60000 });

export const RequestButtons = ({ p, small }) => {
  const { accept, decline } = useFriendActions();
  const pad = small ? "px-2.5 py-1 text-[11px]" : "px-3 py-1.5 text-xs";
  return (
    <div className="flex gap-1.5">
      <button onClick={() => accept(p)} data-testid={`accept-request-${p.user_id}`}
        className={`flex items-center gap-1 rounded-full bg-sky-400 text-[#06121c] font-medium hover:bg-sky-300 transition-colors ${pad}`}><Check size={12} /> Accept</button>
      <button onClick={() => decline(p)} data-testid={`decline-request-${p.user_id}`}
        className={`flex items-center gap-1 rounded-full border border-white/15 text-slate-300 hover:border-red-400/60 hover:text-red-300 transition-colors ${pad}`}><X size={12} /> Decline</button>
    </div>
  );
};

export const FriendRequests = () => {
  const { data } = useFriendRequests();
  const incoming = data?.incoming || [];
  if (!incoming.length) return null;
  return (
    <div className="mt-8 rounded-xl border border-sky-400/25 bg-sky-400/[0.06] px-4 py-3" data-testid="friend-requests">
      <p className="eyebrow !text-sky-300/80 mb-3">Friend requests</p>
      <div className="flex flex-col gap-2">
        {incoming.map((p) => (
          <div key={p.user_id} className="flex items-center justify-between gap-3" data-testid={`friend-request-${p.user_id}`}>
            <span className="flex items-center gap-2 text-sm"><Avatar f={p} /> {p.name} <span className="text-slate-500 text-xs">wants to share travel plans</span></span>
            <RequestButtons p={p} />
          </div>
        ))}
      </div>
    </div>
  );
};
